import { useEffect, useState } from "react";
import NavbarCustom from "../../Components/NavbarCustom";
import "./preferences.css";
import { usePreferences } from "../../APIContext/PreferencesContext";
import { useNavigate } from "react-router-dom";
import { useParent } from "../../APIContext/ParentContext";

export default function Preferences() {
  const navigate = useNavigate();
  const { fetchSports, addPreferedSports, fetchPreferedSports } =
    usePreferences();
  const { fetchLSParentDetails } = useParent();
  const [sports, setSports] = useState([]);
  const [formData, setFormData] = useState([]); // holds selected sport IDs like [40,41]

  // Fetch sports and user's preferred sports on mount
  useEffect(() => {
    const getSports = async () => {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      if (userDetails.is_self_pay === true) {
        navigate("/session-sports?type=1-1");
        return;
      }

      try {
        const sportsdata = await fetchSports();
        const preferencesdata = await fetchPreferedSports();

        setSports(sportsdata || []);

        if (preferencesdata && preferencesdata.length > 0) {
          setFormData(preferencesdata.map((p) => p.id));
        }
      } catch (err) {
        console.error("Error fetching sports:", err);
      }
    };
    getSports();
  }, []);

  const handleCheckboxChange = (id) => {
    setFormData((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = { preferred_sports: formData };
    try {
      await addPreferedSports(data);
      const preferencesdata = await fetchPreferedSports();
      await fetchLSParentDetails();
      setFormData([]);
      navigate("/list-of-sports");
    } catch (error) {
      console.error("Error saving preferences:", error);
    }
  };

  return (
    <>
      <NavbarCustom />
      <div className="p-container">
        <h2 className="black-text-clip">Preferences</h2>
        <form className="p-sports-container" onSubmit={handleSubmit}>
          <h3 className="black-text-clip">Sports</h3>
          <div className="p-sports-list">
            {sports.length > 0 ? (
              sports.map((item) => (
                <div className="p-sport-item" key={item.id}>
                  <input
                    id={`name-${item.id}`}
                    type="checkbox"
                    value={item.id}
                    checked={formData.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                  <label
                    className="black-text-clip"
                    htmlFor={`name-${item.id}`}
                  >
                    {item.name}
                  </label>
                </div>
              ))
            ) : (
              <div className="p-sport-item black-text-clip">
                Loading sports...
              </div>
            )}
          </div>
          <button type="submit" className="preference-p-submit-button">
            Proceed
          </button>
        </form>
      </div>
    </>
  );
}
